import { useState } from "react";
import { Check } from "lucide-react";
import { JOB_STEPS } from "../CreateJobPage";

const publicationTypes = [
  {
    label: "Publish after payment",
    desc: "The post becomes visible as soon as the stored-card payment is authorised.",
    value: 1,
    isRecommended: true,
  },
  {
    label: "Schedule publication",
    desc: "Authorise payment now and choose the date and time the post becomes visible.",
    value: 2,
  },
];

const Step7 = ({ activeStep }) => {
  const [selectedPublicationType, setSelectedPublicationType] = useState(1);

  return (
    <>
      {/* Header */}
      <div className="flex border-b pb-3">
        <div className="flex flex-col gap-0.5 flex-1">
          <span className="text-xss font-bold text-light-black uppercase">
            Step {String(activeStep).padStart(2, "0")} /{" "}
            {JOB_STEPS[activeStep - 1]?.label}
          </span>
          <span className="font-semibold text-xl">
            {JOB_STEPS[activeStep - 1]?.title}
          </span>
          <span className="text-xss font-medium text-light-black">
            {JOB_STEPS[activeStep - 1]?.subtitle}
          </span>
        </div>
        <span className="self-end text-xss font-bold text-light-black uppercase leading-3">
          {JOB_STEPS[activeStep - 1]?.tagline}
        </span>
      </div>
      {/* Publication timing */}
      <div className="rounded-md border overflow-hidden mt-5">
        <div className="flex items-center justify-between border-b px-4 py-2.5 bg-slate-50">
          <div className="flex items-center gap-3">
            <div className="flex items-center justify-center rounded-full h-7 w-7 bg-slate-50 border text-xss font-bold text-light-black">
              01
            </div>
            <div className="flex flex-col">
              <span className="font-bold text-xs">
                When should this job post go live?
              </span>
              <span className="text-xss font-medium text-light-black">
                Publish after payment or authorise payment now and schedule a
                future release.
              </span>
            </div>
          </div>

          <div className="rounded-full px-2 py-1 font-bold text-xsss text-green-800 uppercase bg-green-100">
            Publication control
          </div>
        </div>

        <div className="flex flex-col p-4 gap-4">
          {/* Post Type */}
          <div className="flex gap-3">
            {publicationTypes?.map((publicationType) => {
              const isSelected =
                publicationType?.value === selectedPublicationType;
              return (
                <button
                  onClick={() =>
                    setSelectedPublicationType(publicationType?.value)
                  }
                  className={`flex rounded-md p-4 gap-3 flex-1 ${isSelected ? "border-l-[3.5px] border-slate-600 border bg-slate-50" : "border"}`}
                >
                  <div className="rounded-full border w-4 h-4 shrink-0 border-light-grey"></div>
                  <div className="flex flex-col gap-1 flex-1 text-left">
                    <span className="text-black text-sm font-semibold">
                      {publicationType?.label}
                    </span>
                    <span className="text-xss text-light-black font-medium">
                      {publicationType?.desc}
                    </span>
                  </div>
                  {publicationType?.isRecommended ? (
                    <div className="bg-green-100 text-green-800 rounded-full py-0.5 px-3 uppercase font-bold text-xsss w-max h-max">
                      recommended
                    </div>
                  ) : null}
                </button>
              );
            })}
          </div>

          <div className="flex items-center justify-between border rounded-md px-3.5 py-3 gap-1.5 ">
            <label className="uppercase text-xsss font-bold text-light-black tracking-wider">
              publishing plan
            </label>
            <span className="text-content-muted text-xss font-bold">
              Publish immediately after payment
            </span>
          </div>

          <div className="flex items-center gap-5 border-l-[3px] border-slate-600 bg-slate-100 px-4 py-3.5">
            <span className="uppercase font-bold text-xss text-slate-600 shrink-0">
              Publication checkpoint
            </span>
            <span className="text-xss font-medium text-light-black">
              Payment authorisation happens on the next step. This setting
              controls when the post becomes visible; it does not charge the
              stored card.
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default Step7;
